module.exports = __webpack_public_path__ + "static/Abacus-LEHMANN-und-PARTNER-6cac21de01303e1d3a2eae81f83fc352.pdf";